<template>
    <div class="base-panel">
        <div class="base-panel-head space-between">
            <div>累计节能减排CO₂</div>
        </div>
        <div class="base-panel-body vertical-center">
            <div class="content">
                <div><i class="fa fa-pagelines icon"></i></div>
                <div class="title">{{data | fixedLength}} <small>吨</small></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CO2",
        props:{
            data: {
                type: Number,
                default: 0
            }
        }
    }
</script>

<style lang="less" scoped>
    .content {
        text-align: center;
    }
    .icon{
        font-size: 100px;
        color: #1ab394;
    }
    .title{
        font-size: 30px;
    }
</style>